export enum ServicePackageTypeVariablePriceEnum {
  HumanContact = 1,
  DigitalContact = 2,
}
